import { SvgIcon, SvgIconProps } from "@mui/material";

export const ConfigurationIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 24 24" fill="none" width="18" height="18">
    <path
      d="M15 22.75H9C3.57 22.75 1.25 20.43 1.25 15V9C1.25 3.57 3.57 1.25 9 1.25H15C20.43 1.25 22.75 3.57 22.75 9V15C22.75 20.43 20.43 22.75 15 22.75ZM9 2.75C4.39 2.75 2.75 4.39 2.75 9V15C2.75 19.61 4.39 21.25 9 21.25H15C19.61 21.25 21.25 19.61 21.25 15V9C21.25 4.39 19.61 2.75 15 2.75H9Z"
      fill="currentColor"
    />
    <path
      d="M15.58 19.2501C15.17 19.2501 14.83 18.9101 14.83 18.5001V14.6001C14.83 14.1901 15.17 13.8501 15.58 13.8501C15.99 13.8501 16.33 14.1901 16.33 14.6001V18.5001C16.33 18.9101 15.99 19.2501 15.58 19.2501Z"
      fill="currentColor"
    />
    <path
      d="M15.58 8.2C15.17 8.2 14.83 7.86 14.83 7.45V5.5C14.83 5.09 15.17 4.75 15.58 4.75C15.99 4.75 16.33 5.09 16.33 5.5V7.45C16.33 7.86 15.99 8.2 15.58 8.2Z"
      fill="currentColor"
    />
    <path
      d="M15.58 13.4C13.73 13.4 12.23 11.9 12.23 10.05C12.23 8.19995 13.73 6.69995 15.58 6.69995C17.43 6.69995 18.93 8.19995 18.93 10.05C18.93 11.9 17.42 13.4 15.58 13.4ZM15.58 8.19995C14.56 8.19995 13.73 9.02995 13.73 10.05C13.73 11.07 14.56 11.9 15.58 11.9C16.6 11.9 17.43 11.07 17.43 10.05C17.43 9.02995 16.59 8.19995 15.58 8.19995Z"
      fill="currentColor"
    />
    <path
      d="M8.42004 19.25C8.01004 19.25 7.67004 18.91 7.67004 18.5V16.55C7.67004 16.14 8.01004 15.8 8.42004 15.8C8.83004 15.8 9.17004 16.14 9.17004 16.55V18.5C9.17004 18.91 8.84004 19.25 8.42004 19.25Z"
      fill="currentColor"
    />
    <path
      d="M8.42004 10.15C8.01004 10.15 7.67004 9.81 7.67004 9.4V5.5C7.67004 5.09 8.01004 4.75 8.42004 4.75C8.83004 4.75 9.17004 5.09 9.17004 5.5V9.4C9.17004 9.81 8.84004 10.15 8.42004 10.15Z"
      fill="currentColor"
    />
    <path
      d="M8.41995 17.3001C6.56995 17.3001 5.06995 15.8001 5.06995 13.9501C5.06995 12.1001 6.56995 10.6001 8.41995 10.6001C10.2699 10.6001 11.7699 12.1001 11.7699 13.9501C11.7699 15.8001 10.2699 17.3001 8.41995 17.3001ZM8.41995 12.1001C7.39995 12.1001 6.56995 12.9301 6.56995 13.9501C6.56995 14.9701 7.39995 15.8001 8.41995 15.8001C9.43995 15.8001 10.2699 14.9701 10.2699 13.9501C10.2699 12.9301 9.44995 12.1001 8.41995 12.1001Z"
      fill="currentColor"
    />
    ;
  </SvgIcon>
);
